"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.discriminant = discriminant;
function discriminant(parsedDiscriminant, rawDiscriminant) {
    return {
        parsedDiscriminant,
        rawDiscriminant,
    };
}
